import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { PriceManagement } from '../modal';

export default function reducer(state: PriceManagement = new PriceManagement(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.PRICE_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.PRICE_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.PRICE_MGMT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
